<div class="partners-page">
  <div class="partners-card">
    <div class="card-heading">
      <span class="card-title">Delivery Partners</span>
      <span class="card-subtitle">
        Fork & Find supports fully managed delivery integrations by default. If you prefer, you can
        connect your own delivery partners such as Uber Eats or DoorDash. These partners integrate
        seamlessly with Fork & Find to sync orders, menus, and order status in real time.
      </span>
    </div>

    <div class="partner-list">
      <!-- Uber Eats — the connected integration, shown only when the UBER flag is ACTIVE -->
      @if (isShowUberEatsCard) {
        <div class="partner-row">
          <span class="partner-logo">
            <img class="uber-eats" src="assets/uber_eats.png" alt="Uber Eats" />
          </span>

          <div class="partner-text">
            <div class="partner-name-line">
              <span class="partner-name">Uber Eats</span>
              <span class="tag recommended">Recommended</span>
              @if (uberEatsStoreName) {
                <span class="tag store-name">{{ uberEatsStoreName }}</span>
              }
            </div>
            <span class="partner-desc">
              Uber Eats is our fully integrated delivery partner, designed to work seamlessly with
              the Fork & Find platform.
            </span>
          </div>

          <div class="partner-actions">
            @if (!uberEatsRestusurentStatus) {
              <button
                type="button"
                class="connect-btn primary"
                (click)="getUberEatsAuthorizationDetails()"
              >
                Connect
              </button>
            } @else {
              <button type="button" class="connect-btn" (click)="getUberEatsAuthorizationDetails()">
                Reconnect
              </button>
              <button type="button" class="connect-btn danger" (click)="disconnectConfirmation()">
                Disconnect
              </button>
            }
            <button
              type="button"
              class="settings-btn"
              (click)="openUberEatsSetup()"
              aria-label="Uber Eats settings"
            >
              <i class="bx bx-dots-vertical"></i>
            </button>
          </div>
        </div>
      }

      <!-- Partners not yet integrated -->
      @for (partner of upcomingPartners; track partner.name) {
        <div class="partner-row muted">
          @if (partner.logo && !failedLogos[partner.name]) {
            <span class="partner-logo" [class.wide]="partner.wideLogo">
              <img
                class="brand-logo"
                [src]="partner.logo"
                [alt]="partner.name"
                (error)="onLogoError(partner.name)"
              />
            </span>
          } @else {
            <span class="partner-logo letter" [style.color]="partner.color">
              {{ partner.initial }}
            </span>
          }

          <div class="partner-text">
            <div class="partner-name-line">
              <span class="partner-name">{{ partner.name }}</span>
              <span class="tag coming-soon">Coming Soon</span>
            </div>
            <span class="partner-desc">{{ partner.description }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
